// FIXME: update to use a const object instead of a typescript enum
// eslint-disable-next-line @box/platform/no-enums
export enum ScimProviderType {
  Default = 0,
  AzureAd = 1,
  Okta = 2,
  OneLogin = 3,
  JumpCloud = 4,
  GoogleWorkspace = 5,
  Rippling = 6,
}
